import {
  getStudents,
  getStudentResources,
  getSharedStudent,
  getRecentStudents,
  deleteStudentResource
} from '@/api/library.js'

import { CONTENT_TYPES } from '@/util/access_visibility'

export default {
  namespaced: true,
  state: {
    students: [],
    recentStudents: [],
    loadingStudents: true,

    currentStudent: {},
    loadingResources: true,
    goals: [],
    strategies: [],
    presentlevels: [],
    resources: [],

    filters: {
      goals: 'All Subjects',
      strategies: 'All Subjects',
      presentlevel: 'All Subjects'
    }
  },
  mutations: {
    setGoals(state, goals) {
      state.goals = goals
    },
    setStrategies(state, strats) {
      state.strategies = strats
    },
    setPresentLevels(state, presentlevels) {
      state.presentlevels = presentlevels
    },
    setResources(state, resources) {
      state.resources = resources
    },
    setStudents(state, students) {
      state.students = students
    },
    setRecentStudents(state, students) {
      state.recentStudents = students
    },
    setStudentsLoading(state, bool) {
      state.loadingStudents = bool
    },
    setResourcesLoading(state, bool) {
      state.loadingResources = bool
    },
    setCurrentStudent(state, student) {
      state.currentStudent = student
    },
    setFilter(state, info) {
      state.filters[info.type] = info.filter
    },
    resetFilters(state) {
      state.filters = {
        goals: 'All Subjects',
        strategies: 'All Subjects',
        presentlevel: 'All Subjects'
      }
    },
    removeResource(state, info) {
      if (info.type === CONTENT_TYPES.SAVED_STRATEGY) {
        state.strategies = state.strategies.filter(strat => {
          return strat.content_uuid !== info.uuid
        })
      } else if (
        info.type === CONTENT_TYPES.SAVED_GOAL ||
        info.type === CONTENT_TYPES.SAVED_SUPER_PAGE
      ) {
        state.goals = state.goals.filter(goal => {
          return goal.content_uuid !== info.uuid
        })
      } else if (info.type === CONTENT_TYPES.PRESENTLEVEL) {
        state.presentlevels = state.presentlevels.filter(pl => {
          return pl.content_uuid !== info.uuid
        })
      } else if (info.type === CONTENT_TYPES.RESOURCE) {
        state.resources = state.resources.filter(r => {
          return r.content_uuid !== info.uuid
        })
      }
    }
  },
  actions: {
    fetchStudents(context, userId) {
      context.commit('setStudentsLoading', true)
      return getStudents(userId).then(data => {
        context.commit('setStudents', data.collections)
        context.commit('setStudentsLoading', false)
      })
    },
    fetchRecentStudents(context, userId) {
      return getRecentStudents(userId).then(data => {
        context.commit('setRecentStudents', data)
      })
    },
    fetchResourcesForStudent(context, { studentId, params }) {
      context.commit('setResourcesLoading', true)
      return getStudentResources(studentId, params).then(data => {
        setResourcesForStudent(context, data)
        context.commit('setResourcesLoading', false)
        return data
      }).catch(e => console.error(e))
    },
    fetchResourcesForSharedStudent(context, { shareToken, params }) {
      context.commit('setResourcesLoading', true)
      return getSharedStudent(shareToken, params).then(data => {
        setResourcesForStudent(context, data)
        context.commit('setResourcesLoading', false)
        return data
      })
    },
    setFilter(context, info) {
      return context.commit('setFilter', info)
    },
    deleteResource(context, info) {
      return deleteStudentResource(info.collection, info.uuid, info.type).then(() => {
        context.commit('removeResource', info)
      })
    }
  },
  getters: {
    currentStudentContentCount(state) {
      return (
        state.goals.length +
        state.strategies.length +
        state.presentlevels.length +
        state.resources.length
      )
    },
    folderCount(state) {
      return (state.students || []).length
    }
  }
}

function setResourcesForStudent(context, { collection }) {
  context.commit('setCurrentStudent', collection)
  let goals = []
  let strategies = []
  let presentlevels = []
  let resources = []

  if (collection.content) {
    collection.content.forEach(function(resource) {
      if (resource.content_body_error === 'not found' || !resource.content_body) {
        return
      }
      if (
        resource.content_type === CONTENT_TYPES.SAVED_GOAL ||
        resource.content_type === CONTENT_TYPES.SAVED_SUPER_PAGE
      ) {
        goals.push(resource)
      } else if (resource.content_type === CONTENT_TYPES.SAVED_STRATEGY) {
        strategies.push(resource)
      } else if (resource.content_type === CONTENT_TYPES.PRESENTLEVEL) {
        presentlevels.push(resource)
      } else if (resource.content_type === CONTENT_TYPES.RESOURCE) {
        resources.push(resource)
      }
    })
  }
  context.commit('setStrategies', strategies)
  context.commit('setGoals', goals)
  context.commit('setPresentLevels', presentlevels)
  context.commit('setResources', resources)
}
